(() => {
  const initializeModal = (modal) => {
    if (modal.dataset.oaInformationReady === 'true') return;

    const card = modal.querySelector('[data-oa-information-card]');
    const closeButton = modal.querySelector('[data-oa-information-close]');
    const mediaLink = modal.querySelector('a.oa-information-modal__media');
    const showOnce = modal.dataset.showOnce === 'true';
    const storageKey = `oa-information-modal-seen-${modal.dataset.sectionId}`;

    const hasBeenSeen = () => {
      if (!showOnce || window.Shopify?.designMode) return false;

      try {
        return window.sessionStorage.getItem(storageKey) === 'true';
      } catch (_error) {
        return false;
      }
    };

    const markAsSeen = () => {
      if (!showOnce || window.Shopify?.designMode) return;

      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (_error) {
        // Storage may be unavailable in private browsing; the modal can still close normally.
      }
    };

    const closeModal = () => {
      if (modal.open) modal.close();
    };

    const openModal = () => {
      if (modal.open || hasBeenSeen()) return;

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      document.documentElement.classList.add('oa-information-modal-open');
    };

    closeButton?.addEventListener('click', closeModal);
    mediaLink?.addEventListener('click', () => {
      markAsSeen();
      closeModal();
    });

    modal.addEventListener('click', (event) => {
      if (!card || card.contains(event.target)) return;
      closeModal();
    });

    modal.addEventListener('close', () => {
      markAsSeen();
      document.documentElement.classList.remove('oa-information-modal-open');
    });

    modal.addEventListener('cancel', () => {
      markAsSeen();
      document.documentElement.classList.remove('oa-information-modal-open');
    });

    modal.dataset.oaInformationReady = 'true';

    const delay = Math.max(0, Number(modal.dataset.delay || 0)) * 1000;
    window.setTimeout(openModal, delay);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-oa-information-modal]').forEach(initializeModal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const modal = event.target.querySelector('[data-oa-information-modal]');
    if (modal && !modal.open) modal.showModal();
  });
})();
